
export class MultiDeletePasswordLabelEntry {
    id: number;
    tags: number[] = [];
}